import { compose, mdsWidget } from 'dojo/_base/declare';
import FinderBaseV2 from '../FinderBase/FinderBaseV2';
import { ServerMonitor } from "./ServermonitorTypes";
import lang from 'dojo/_base/lang';
import ServermonitorEditor from './ServermonitorEditor';

class ServermonitorFinder extends compose(FinderBaseV2) {

    private _onClickRow(row: StaticTable.StaticTableRow<ServerMonitor>) {
        let entity = row.rowGroup.entity;

        let editor = new ServermonitorEditor();
        editor.setup(entity, this.getTabContainerName());
    }

    private _tableFormatter(cell: StaticTable.StaticTableCell<ServerMonitor>): boolean {
        let name = cell.name;
        let node = cell.contentnode;
        let value = cell.value;
        let entity = cell.entity;

        switch (name) {
            case "tmp_memory":
                node.innerHTML = value + "%";
                return true;
                break;
            case "hostname":
                let colorClass = entity.power_state_vm === "POWERED_ON" ? "w3-text-green" : "w3-text-red";
                //let icon = this.UiModder.domConstruct.create("i", { className: colorClass + " fas fa-ligthbulb" });
                node.innerHTML = `<i class='fas fa-lightbulb ${colorClass}'></i>` + " " + value;
                return true;
                break;
            //case "tmp_uptime_minutes":
            //    node.innerHTML = value + " min";
            //    return true;
            //    break;
        }


        return false;
    }

    postCreate(): void {
        super.postCreate.apply(this, arguments as any);

        this.setupFinderWithCallfunctions(
            "Webtool_API__ServerMonitorFinder_GetFinderConfig",
            "Webtool_API__ServerMonitorFinder_GetListJSON",
            lang.hitch(this, this._onClickRow),
            lang.hitch(this, this._tableFormatter),
        );
    }

    startup(): void {
        super.startup.apply(this, arguments as any);
    }
}

export default mdsWidget(ServermonitorFinder);